import { ALLOWED_SCAN_ROUTES, UNKNOWN_SCAN_ROUTE } from '../constants/scanRouteSections.const';
import { type ScanRouteContext, type ScanRouteSection } from '../types/scanContext.type';

const isScanRouteSection = (segment: string): segment is ScanRouteSection =>
  ALLOWED_SCAN_ROUTES.includes(segment as ScanRouteSection);

/**
 * Reduces a pathname to the app section the scan happened in. Sections outside
 * the allowlist report `unknown` without their pathname, so routes that carry a
 * secret (`/reset-password/:token`) never reach a scan event.
 */
export const resolveScanRouteContext = (pathname: string): ScanRouteContext => {
  const section = pathname.split('/')[1];

  if (!isScanRouteSection(section)) return { route: UNKNOWN_SCAN_ROUTE };

  return { raw_path: pathname, route: section };
};
